import { useEffect } from "react";

import { useAppSelector } from "store";

export const useUmamiIdentify = () => {
  const user = useAppSelector((state) => state.user);
  const userId = user?._id;
  const organisationId = user?.ownerOrganisation?._id;

  useEffect(() => {
    if (!userId || !window.umami?.identify) {
      return;
    }

    window.umami.identify(
      userId,
      organisationId ? { organisation: organisationId } : undefined,
    );
  }, [userId, organisationId]);
};

export default useUmamiIdentify;
